// Category information configuration
export const CATEGORY_INFO = {
  "TadReamk AI": {
    title: "TadReamk AI",
    abstract:
      "Explore how artificial intelligence is revolutionizing trademark search, patent analysis, and intellectual property protection. Discover cutting-edge AI applications in brand protection and innovation discovery.",
  },
  "TadReamk Design": {
    title: "TadReamk Design",
    abstract:
      "Dive into the art and science of trademark design. Learn about visual psychology, design trends, and best practices for creating memorable, legally compliant brand identities.",
  },
  "IP Law": {
    title: "IP Law",
    abstract:
      "Understand the legal landscape of intellectual property. From trademark law to patent litigation, get expert insights on IP legal matters, compliance, and protecting your rights.",
  },
  "TadReamk-AIGC": {
    title: "TadReamk AIGC",
    abstract:
      "Discover the world of AI-generated content. From video production to image creation, explore how generative AI is transforming creative workflows and content production.",
  },
  "TadReamk-ERP": {
    title: "TadReamk ERP",
    abstract:
      "Learn about enterprise resource planning systems and business process automation. Explore how modern ERP solutions streamline operations and drive organizational efficiency.",
  },
};

export default CATEGORY_INFO;
